import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { VATRateDto } from './vat-rate.dto';
import { IsOptional } from 'class-validator';

export class ProductCategoryDto extends BaseDto {
  name: string;
  photoURL?: string;
  code?: string;
  startDate?: Date;
  endDate?: Date;
  merchantGroupId?: number;
  parentId?: number;
  level?: number;
  printingSequence?: number;
  vatRate: VATRateDto;

  active?: boolean;

  @IsOptional()
  accountingName?: string;

  @IsOptional()
  nominalCode?: string;

  @IsOptional()
  nominalReportingId?: number;

  @IsOptional()
  merchantGroup?: MerchantGroupDto;
}
